export default __webpack_public_path__ + "static/media/undraw-social-sharing-ibwq.39daf276.svg";